
// const PrivacyPolicy = () => {
//   const sectionStyle = {
//     marginBottom: '2rem',
//   };

//   const h2Style = {
//     fontSize: '1.125rem',
//     fontWeight: '600',
//     color: '#111827',
//     marginBottom: '0.75rem',
//     paddingBottom: '0.4rem',
//     borderBottom: '1px solid #e5e7eb',
//   };

//   const h3Style = {
//     fontSize: '0.95rem',
//     fontWeight: '600',
//     color: '#1f2937',
//     marginTop: '1rem',
//     marginBottom: '0.35rem',
//   };

//   const pStyle = {
//     color: '#374151',
//     fontSize: '0.9rem',
//     lineHeight: '1.7',
//     marginBottom: '0.75rem',
//   };

//   const ulStyle = {
//     listStyleType: 'disc',
//     listStylePosition: 'inside',
//     color: '#374151',
//     fontSize: '0.9rem',
//     marginBottom: '0.75rem',
//     paddingLeft: '0.5rem',
//   };

//   const liStyle = { marginBottom: '0.3rem', lineHeight: '1.6' };

//   const highlightStyle = {
//     borderLeft: '3px solid #3b82f6',
//     backgroundColor: '#eff6ff',
//     padding: '0.6rem 1rem',
//     borderRadius: '0 0.375rem 0.375rem 0',
//     marginBottom: '0.75rem',
//   };

//   const highlightTextStyle = {
//     fontSize: '0.875rem',
//     color: '#1d4ed8',
//     margin: 0,
//     lineHeight: '1.6',
//   };

//   const cardGridStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
//     gap: '0.625rem',
//     marginBottom: '0.75rem',
//   };

//   const cardStyle = {
//     backgroundColor: '#f9fafb',
//     borderRadius: '0.5rem',
//     padding: '0.75rem 1rem',
//     border: '1px solid #e5e7eb',
//   };

//   const cardLabelStyle = {
//     fontSize: '0.7rem',
//     fontWeight: '600',
//     color: '#6b7280',
//     textTransform: 'uppercase',
//     letterSpacing: '0.05em',
//     margin: '0 0 0.25rem',
//   };

//   const cardValStyle = {
//     fontSize: '0.875rem',
//     color: '#111827',
//     margin: 0,
//   };

//   const stepStyle = {
//     display: 'flex',
//     gap: '0.75rem',
//     marginBottom: '1rem',
//     alignItems: 'flex-start',
//   };

//   const stepNumStyle = {
//     width: '24px',
//     height: '24px',
//     borderRadius: '50%',
//     backgroundColor: '#dbeafe',
//     color: '#1d4ed8',
//     fontSize: '0.75rem',
//     fontWeight: '600',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     flexShrink: 0,
//     marginTop: '2px',
//   };

//   const stepTitleStyle = {
//     fontSize: '0.9rem',
//     fontWeight: '600',
//     color: '#111827',
//     margin: '0 0 0.2rem',
//   };

//   const stepTextStyle = {
//     fontSize: '0.85rem',
//     color: '#374151',
//     lineHeight: '1.6',
//     margin: 0,
//   };

//   const contactBoxStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.75rem',
//     padding: '0.75rem 1rem',
//     border: '1px solid #e5e7eb',
//     borderRadius: '0.5rem',
//     marginTop: '0.5rem',
//   };

//   const contactIconStyle = {
//     width: '36px',
//     height: '36px',
//     borderRadius: '50%',
//     backgroundColor: '#dbeafe',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     flexShrink: 0,
//   };

//   return (
//     <div style={{ backgroundColor: '#f3f4f6', padding: '1.5rem', minHeight: '100vh' }}>
//       <div style={{
//         maxWidth: '720px',
//         margin: '0 auto',
//         backgroundColor: '#ffffff',
//         borderRadius: '0.75rem',
//         boxShadow: '0 4px 6px rgba(0,0,0,0.07)',
//         padding: '2rem',
//       }}>
//         {/* Header */}
//         <div style={{ marginBottom: '2rem', paddingBottom: '1.25rem', borderBottom: '2px solid #e5e7eb' }}>
//           <span style={{
//             display: 'inline-block',
//             backgroundColor: '#dbeafe',
//             color: '#1d4ed8',
//             fontSize: '0.75rem',
//             fontWeight: '600',
//             padding: '3px 10px',
//             borderRadius: '9999px',
//             marginBottom: '0.75rem',
//           }}>B2B Mobile Recharge Platform</span>
//           <h1 style={{ fontSize: '1.625rem', fontWeight: '700', color: '#111827', margin: '0 0 0.4rem' }}>
//             Privacy Policy — Mani Vasu
//           </h1>
//           <p style={{ fontSize: '0.85rem', color: '#6b7280', margin: 0 }}>
//             Provided by <strong style={{ fontWeight: '600', color: '#374151' }}>Mani Vasu Telecom</strong> &nbsp;·&nbsp; Effective: 2 April 2026 &nbsp;·&nbsp; 
//           </p>
//         </div>

//         {/* 1. Introduction */}
//         <div style={sectionStyle}>
//           <h2 style={h2Style}>1. Introduction</h2>
//           <p style={pStyle}>
//             Mani Vasu is an Android application provided by Mani Vasu Telecom for registered retailers. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform. By accessing or using the App, you agree to the terms described herein.
//           </p>
//           <div style={highlightStyle}>
//             <p style={highlightTextStyle}>
//               This App is intended solely for registered business entities and their authorised personnel (adults 18 years and above).
//             </p>
//           </div>
//         </div>

//         {/* 2. Information We Collect */}
//         <div style={sectionStyle}>
//           <h2 style={h2Style}>2. Information We Collect</h2>

//           <h3 style={h3Style}>Business &amp; Account Information (from Retailers)</h3>
//           <div style={cardGridStyle}>
//             <div style={cardStyle}>
//               <p style={cardLabelStyle}>Business</p>
//               <p style={cardValStyle}>Business name · Business address</p>
//             </div>
//             <div style={cardStyle}>
//               <p style={cardLabelStyle}>Account Holder</p>
//               <p style={cardValStyle}>Full name · Mobile number · Email address</p>
//             </div>
//           </div>

//           <h3 style={h3Style}>Transaction Data (from Customers)</h3>
//           <p style={pStyle}>Collected from the retailer solely to complete a recharge transaction:</p>
//           <div style={cardGridStyle}>
//             <div style={cardStyle}>
//               <p style={cardLabelStyle}>Transaction</p>
//               <p style={cardValStyle}>Customer mobile number · Operator · Recharge amount · Transaction status &amp; timestamps</p>
//             </div>
//           </div>

//           <h3 style={h3Style}>Device &amp; Usage Data</h3>
//           <p style={pStyle}>Device type, OS version, IP address, app usage logs, and crash reports — used solely to improve App performance and functionality.</p>

//           <div style={highlightStyle}>
//             <p style={highlightTextStyle}>
//               We do not collect identity proof, location history, or any other device data from retailers.
//             </p>
//           </div>
//         </div>

//         {/* 3. How We Use Your Information */}
//         <div style={sectionStyle}>
//           <h2 style={h2Style}>3. How We Use Your Information</h2>
//           <ul style={ulStyle}>
//             <li style={liStyle}>Create and manage your business account</li>
//             <li style={liStyle}>Process mobile recharge transactions on behalf of your business</li>
//             <li style={liStyle}>Verify identity and authorise transactions via OTP</li>
//             <li style={liStyle}>Provide customer support and resolve disputes</li>
//             <li style={liStyle}>Improve App performance, features, and user experience</li>
//             <li style={liStyle}>Send transactional notifications, alerts, and service updates</li>
//             <li style={liStyle}>Comply with legal obligations and regulatory requirements</li>
//             <li style={liStyle}>Detect and prevent fraud, unauthorised access, or misuse</li>
//           </ul>
//         </div>

//         {/* 4. Sharing of Information */}
//         <div style={sectionStyle}>
//           <h2 style={h2Style}>4. Sharing of Information</h2>
//           <p style={pStyle}>We do not sell, trade, or rent your personal or business information to third parties. Information is shared only in these circumstances:</p>
//           <ul style={ulStyle}>
//             <li style={liStyle}><strong style={{ fontWeight: '600' }}>Transaction processing</strong> — Mobile number, operator, and recharge amount are shared with payment gateways and telecom operators solely to complete transactions, under strict confidentiality agreements.</li>
//             {/* <li style={liStyle}><strong style={{ fontWeight: '600' }}>Legal compliance</strong> — When required b y applicable law, court order, or government authority.</li> */}
//             <li style={liStyle}><strong style={{ fontWeight: '600' }}>Business transfers</strong> — In the event of a merger, acquisition, or asset sale, with prior notice to users.</li>
//             <li style={liStyle}><strong style={{ fontWeight: '600' }}>Fraud prevention</strong> — To detect or prevent fraudulent transactions or security threats.</li>
//           </ul>
//         </div>

//         {/* 5. Data Retention */}
//         <div style={sectionStyle}>
//           <h2 style={h2Style}>5. Data Retention</h2>
//           <p style={pStyle}>
//             We retain your information for as long as your account is active or as required to provide services. Transaction records are retained for a minimum of <strong style={{ fontWeight: '600' }}>5 years</strong> to comply with Indian financial and tax regulations — even after account deletion. You may request account deletion, however certain data may be retained as required by law.
//           </p>
//         </div>

//         {/* 6. Data Security */}
//         <div style={sectionStyle}>
//           <h2 style={h2Style}>6. Data Security</h2>
//           <p style={pStyle}>We implement industry-standard security measures including:</p>
//           <ul style={ulStyle}>
//             <li style={liStyle}>Encrypted data transmission (HTTPS/TLS)</li>
//             <li style={liStyle}>Secure storage with access controls</li>
//             <li style={liStyle}>Regular security audits and vulnerability assessments</li>
//           </ul>
//           <p style={pStyle}>No method of internet transmission or electronic storage is 100% secure. We cannot guarantee absolute security.</p>
//         </div>

//         {/* 7. Your Rights */}
//         <div style={sectionStyle}>
//           <h2 style={h2Style}>7. Your Rights</h2>
//           <p style={pStyle}>As a user of our App, you have the right to:</p>
//           <ul style={ulStyle}>
//             <li style={liStyle}>Access the personal and business information we hold about you</li>
//             <li style={liStyle}>Request correction of inaccurate or incomplete data</li>
//             <li style={liStyle}>Request deletion of your account and associated data (subject to legal retention requirements)</li>
//             <li style={liStyle}>Withdraw consent for non-essential data processing</li>
//           </ul>
//           <p style={pStyle}>To exercise any of these rights, contact us at the email address provided below.</p>
//         </div>

//         {/* 8. Account Deletion Process */}
//         <div style={sectionStyle}>
//           <h2 style={h2Style}>8. Account Deletion Process</h2>
//           <p style={{ ...pStyle, marginBottom: '1rem' }}>You have the right to request permanent deletion of your account and associated personal data:</p>

//           <div style={stepStyle}>
//             <div style={stepNumStyle}>1</div>
//             <div style={{ flex: 1 }}>
//               <p style={stepTitleStyle}>Submit a deletion request</p>
//               <p style={stepTextStyle}>
//                 Email <a href="mailto:manivashu2011@gmail.com" style={{ color: '#2563eb' }}>manivashu2011@gmail.com</a> with subject "Account Deletion Request – [Your Registered Mobile Number]". Include your registered business name, mobile number, and an optional reason.
//               </p>
//             </div>
//           </div>

//           <div style={stepStyle}>
//             <div style={stepNumStyle}>2</div>
//             <div style={{ flex: 1 }}>
//               <p style={stepTitleStyle}>Identity verification</p>
//               <p style={stepTextStyle}>An OTP will be sent to your registered mobile number. You must confirm it within 24 hours to proceed.</p>
//             </div>
//           </div>

//           <div style={stepStyle}>
//             <div style={stepNumStyle}>3</div>
//             <div style={{ flex: 1 }}>
//               <p style={stepTitleStyle}>Review period — 7 business days</p>
//               <p style={stepTextStyle}>Your account is deactivated. Pending transactions are completed or refunded. A confirmation email is sent once review is complete.</p>
//             </div>
//           </div>

//           <div style={stepStyle}>
//             <div style={stepNumStyle}>4</div>
//             <div style={{ flex: 1 }}>
//               <p style={stepTitleStyle}>Permanent deletion — within 30 days</p>
//               <p style={stepTextStyle}>Your name, business name, business address, and mobile number are permanently deleted from active systems.</p>
//             </div>
//           </div>

//           <div style={highlightStyle}>
//             <p style={highlightTextStyle}>
//               Transaction records are retained for up to 5 years per Indian financial regulations. Data shared with telecom operators or payment processors for completed transactions cannot be recalled. Once deleted, the account cannot be recovered.
//             </p>
//           </div>
//         </div>

//         {/* 9. Children's Privacy */}
//         <div style={sectionStyle}>
//           <h2 style={h2Style}>9. Children's Privacy</h2>
//           <p style={pStyle}>
//             This App is strictly intended for business use by adults (18 years and above). We do not knowingly collect information from minors under 13. If we become aware that a minor has provided personal information, we will take steps to delete it promptly.
//           </p>
//         </div>

//         {/* 10. Third-Party Services */}
//         <div style={sectionStyle}>
//           <h2 style={h2Style}>10. Third-Party Services</h2>
//           <p style={pStyle}>
//             The App integrates with third-party telecom operators and payment processors. These parties have their own privacy policies and we are not responsible for their data practices. We encourage you to review the privacy policies of any third-party services you interact with through the App.
//           </p>
//         </div>

//         {/* 11. Changes to This Policy */}
//         <div style={sectionStyle}>
//           <h2 style={h2Style}>11. Changes to This Privacy Policy</h2>
//           <p style={pStyle}>
//             We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. Users will be notified of significant changes via in-app notification or email. The updated policy will be effective from the date mentioned at the top. Continued use of the App after changes constitutes acceptance of the updated policy.
//           </p>
//         </div>

//         {/* 12. Contact Us */}
//         <div style={sectionStyle}>
//           <h2 style={h2Style}>12. Contact Us</h2>
//           <p style={pStyle}>For questions, concerns, or data requests regarding this Privacy Policy:</p>
//           <div style={contactBoxStyle}>
//             <div style={contactIconStyle}>
//               <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#1d4ed8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//                 <rect x="1" y="3" width="14" height="10" rx="2" />
//                 <path d="M1 5l7 5 7-5" />
//               </svg>
//             </div>
//             <div>
//               <p style={{ fontSize: '0.875rem', fontWeight: '600', color: '#111827', margin: '0 0 0.1rem' }}>Mani Vasu Telecom</p>
//               <a href="mailto:manivashu2011@gmail.com" style={{ fontSize: '0.85rem', color: '#2563eb', textDecoration: 'none' }}>
//                 manivashu2011@gmail.com
//               </a>
//             </div>
//           </div>
         
//         </div>
//       </div>
//     </div>
//   );
// };



import { useState } from "react";

// ─── Data ───────────────────────────────────────────────────────────────────

const sections = [
  {
    num: "1",
    title: "Introduction",
    blocks: [
      { type: "text", text: "Welcome to Mani Vasu. Mani Vasu is a mobile recharge platform that enables registered retailers to perform mobile recharges for their customers. We are committed to protecting the privacy and security of personal information collected through our application." },
      { type: "text", text: "This Privacy Policy explains what information we collect, how we use it, how we protect it, and your rights regarding your data. By using the Mani Vasu application, you agree to the terms of this Privacy Policy." },
    ],
  },
  {
    num: "2",
    title: "Information We Collect",
    blocks: [
      { type: "subheading", text: "2.1 Retailer Onboarding Information" },
      { type: "text", text: "When a retailer registers on the Mani Vasu platform, we collect the following information to verify identity and set up the account:" },
      { type: "bullets", items: ["Business Name – The registered name of the retail business", "Mobile Number – Used as the primary identifier and for login authentication", "Business Address – The physical location of the retailer's business", "Retailer Name – The full name of the individual or proprietor"] },
      { type: "subheading", text: "2.2 Authentication Information" },
      { type: "text", text: "Your registered mobile number is used to authenticate your identity when logging into the Mani Vasu application. We may use OTP (One-Time Password) or similar verification methods for secure login." },
      { type: "subheading", text: "2.3 Transaction Information" },
      { type: "text", text: "When a recharge transaction is initiated and completed through the application, we record the following transaction details:" },
      { type: "bullets", items: ["Customer Mobile Number – The mobile number to be recharged", "Recharge Amount – The denomination or value of the recharge", "Operator Name – The telecom operator for the recharge (e.g., Airtel, Jio, Vi, BSNL)", "Date and Time of Transaction – Timestamp of when the transaction was processed", "Transaction Status – Success, failure, or pending status of the recharge"] },
    ],
  },
  {
    num: "3",
    title: "How We Use Your Information",
    blocks: [
      { type: "text", text: "We use the information collected for the following purposes:" },
      { type: "bullets", items: ["Retailer Registration & Verification – To onboard retailers onto our platform and verify their identity and business details", "Authentication & Login – To securely authenticate retailers when accessing the application using their registered mobile number", "Processing Recharges – To execute mobile recharge transactions on behalf of the retailer and their customers", "Transaction Records – To maintain a complete and accurate history of all recharge transactions for accounting, dispute resolution, and audit purposes", "Customer Support – To assist with inquiries, resolve issues, and provide transaction-related support", "Compliance & Legal Obligations – To comply with applicable Indian laws, regulations, and government directives", "Security & Fraud Prevention – To detect, investigate, and prevent fraudulent activity or unauthorized access", "Service Improvement – To analyse usage patterns and improve the functionality of the Mani Vasu platform"] },
    ],
  },
  {
    num: "4",
    title: "Data Sharing and Disclosure",
    blocks: [
      { type: "text", text: "We do not sell, rent, or trade your personal information to third parties. We may share your information only in the following limited circumstances:" },
      { type: "bullets", items: ["Telecom Operators – Transaction data (mobile number, amount, operator) is shared with the respective telecom operator to process the recharge", "Payment Partners – Financial institutions or payment gateway partners to facilitate and settle transactions", "Legal Authorities – When required by law, court order, or government authority under applicable Indian law", "Business Transfers – In the event of a merger, acquisition, or sale of our business, your data may be transferred to the successor entity"] },
      { type: "text", text: "All third-party partners are required to handle your information in accordance with applicable privacy laws and are prohibited from using it for any other purpose." },
    ],
  },
  {
    num: "5",
    title: "Data Retention",
    blocks: [
      { type: "text", text: "We retain your information for as long as necessary to fulfil the purposes outlined in this Privacy Policy:" },
      { type: "bullets", items: ["Retailer onboarding information is retained for the duration of the active account and for a period thereafter as required by law", "Transaction records are retained for a minimum of 5 years in compliance with applicable Indian financial regulations and record-keeping requirements", "Authentication logs are retained for security monitoring and audit purposes"] },
      { type: "text", text: "If you wish to close your account, please contact us. Upon account closure, we will delete or anonymise personal data that is no longer required, subject to legal retention obligations." },
    ],
  },
  {
    num: "6",
    title: "Data Security",
    blocks: [
      { type: "text", text: "We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. Our security practices include:" },
      { type: "bullets", items: ["Encrypted storage of sensitive data", "Secure HTTPS connections for all data transmission", "OTP-based login authentication", "Access controls limiting data access to authorized personnel only", "Regular security reviews and monitoring"] },
      { type: "text", text: "While we take all reasonable precautions, no method of transmission or storage is 100% secure. We encourage you to keep your login credentials confidential and report any suspicious activity to us immediately." },
    ],
  },
  {
    num: "7",
    title: "Your Rights",
    blocks: [
      { type: "text", text: "As a user of the Mani Vasu platform, you have the following rights regarding your personal data:" },
      { type: "bullets", items: ["Access – You may request a copy of the personal information we hold about you", "Correction – You may request correction of any inaccurate or incomplete information", "Deletion – You may request deletion of your personal data, subject to legal obligations", "Portability – You may request your data in a portable format where technically feasible", "Objection – You may object to certain types of data processing"] },
      { type: "text", text: "To exercise any of these rights, please contact us using the details provided in Section 12 below." },
    ],
  },
  {
    num: "8",
    title: "Account Deletion",
    blocks: [
      { type: "text", text: 'Retailers may request permanent deletion of their Mani Vasu account at any time by navigating to Profile and scrolling to the bottom of the page to tap "Delete Account".' },
      { type: "subheading", text: "8.1 Deletion Request & Waiting Period" },
      { type: "text", text: "Upon submitting a deletion request, a mandatory 3-month (90-day) waiting period will begin. During this period:" },
      { type: "bullets", items: ["Your account will remain in a pending deletion state", "You will not be able to process any new recharge transactions", "Your account data will be preserved until the waiting period concludes"] },
      { type: "subheading", text: "8.2 How to Retain Your Account" },
      { type: "text", text: "If you wish to cancel your deletion request and retain your account during the 3-month waiting period, you must contact our support team directly by phone:" },
      { type: "bullets", items: ["Support Number – 8630102092", "Inform the support representative that you wish to cancel your pending account deletion", "Your account will be restored to active status upon confirmation"] },
      { type: "text", text: "Retention requests cannot be processed through the application — you must contact support directly via the number above." },
      { type: "subheading", text: "8.3 Permanent Deletion" },
      { type: "text", text: "If no retention request is made within the 3-month waiting period, your account and associated personal data will be permanently deleted. This action is irreversible. Transaction records may be retained for the period required under Indian financial regulations." },
    ],
  },
  {
    num: "9",
    title: "Cookies and Device Information",
    blocks: [
      { type: "text", text: "The Mani Vasu application may collect non-personal technical information including device type, operating system version, app version, and IP address for the purpose of improving application performance and security. We do not use advertising trackers or share this information with marketing platforms." },
    ],
  },
  {
    num: "10",
    title: "Children's Privacy",
    blocks: [
      { type: "text", text: "The Mani Vasu application is intended for use by registered retailers and business owners only. It is not directed at individuals under the age of 18. We do not knowingly collect personal information from minors. If you believe a minor has provided us information, please contact us and we will promptly delete it." },
    ],
  },
  {
    num: "11",
    title: "Changes to This Privacy Policy",
    blocks: [
      { type: "text", text: "We may update this Privacy Policy from time to time to reflect changes in our practices, technology, or applicable laws. When we make material changes, we will notify registered users through the application or via the registered mobile number. The updated policy will display the revised effective date at the top of this document." },
      { type: "text", text: "Continued use of the Mani Vasu application after any changes constitutes acceptance of the updated Privacy Policy." },
    ],
  },
  {
    num: "12",
    title: "Contact Us",
    blocks: [
      { type: "text", text: "If you have any questions, concerns, or requests regarding this Privacy Policy or the handling of your personal information, please contact us at:" },
    ],
  },
];

const contactInfo = [
  { icon: "business", text: "Mani Vasu – Recharge Application" },
  { icon: "email", text: "manivashu2011@gmail.com" },
  { icon: "phone", text: "8630102092" },
  { icon: "location", text: "Meerut, Uttar Pradesh, India" },
  { icon: "web", text: "www.manivasu.org" },
];

// ─── Icons ──────────────────────────────────────────────────────────────────

const ShieldIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M12 2L3 6.5V12c0 5.25 3.75 10.15 9 11.25C17.25 22.15 21 17.25 21 12V6.5L12 2z" fill="white" />
  </svg>
);

const CalendarIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z" />
  </svg>
);

const UpdateIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z" />
  </svg>
);

const ChevronIcon = ({ open }) => (
  <svg
    width="20" height="20" viewBox="0 0 24 24" fill="currentColor"
    style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.25s ease" }}
  >
    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
  </svg>
);

const ContactSupportIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="rgba(255,255,255,0.9)">
    <path d="M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2zm1 14.5h-2v-2h2v2zm0-4h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z" />
  </svg>
);

const contactIconMap = {
  business: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="white">
      <path d="M12 7V3H2v18h20V7H12zm-2 12H4v-2h6v2zm0-4H4v-2h6v2zm0-4H4V9h6v2zm0-4H4V5h6v2zm10 12h-8V9h8v10zm-2-8h-4v2h4v-2zm0 4h-4v2h4v-2z" />
    </svg>
  ),
  email: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="white">
      <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
    </svg>
  ),
  phone: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="white">
      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
    </svg>
  ),
  location: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="white">
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
    </svg>
  ),
  web: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="white">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
    </svg>
  ),
};

// ─── Block Renderer ──────────────────────────────────────────────────────────

function renderBlock(block, idx) {
  if (block.type === "text") {
    return (
      <p key={idx} style={{ fontSize: 13.5, color: "#6B7280", lineHeight: 1.65, margin: "0 0 10px" }}>
        {block.text}
      </p>
    );
  }
  if (block.type === "subheading") {
    return (
      <p key={idx} style={{ fontSize: 13, fontWeight: 600, color: "#1F2937", margin: "4px 0 6px" }}>
        {block.text}
      </p>
    );
  }
  if (block.type === "bullets") {
    return (
      <div key={idx} style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 8 }}>
        {block.items.map((item, i) => {
          const parts = item.split(" – ");
          return (
            <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
              <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#1A56DB", flexShrink: 0, marginTop: 7 }} />
              <span style={{ fontSize: 13.5, color: "#6B7280", lineHeight: 1.6 }}>
                {parts.length === 2 ? (
                  <>
                    <strong style={{ fontWeight: 600, color: "#1F2937" }}>{parts[0]} – </strong>
                    {parts[1]}
                  </>
                ) : item}
              </span>
            </div>
          );
        })}
      </div>
    );
  }
  return null;
}

// ─── Section Card ────────────────────────────────────────────────────────────

function SectionCard({ section, defaultOpen }) {
  const [open, setOpen] = useState(defaultOpen || false);

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 14,
        border: `1px solid ${open ? "rgba(26,86,219,0.3)" : "#E5E7EB"}`,
        boxShadow: open
          ? "0 4px 12px rgba(26,86,219,0.08)"
          : "0 1px 4px rgba(0,0,0,0.03)",
        overflow: "hidden",
        transition: "border-color 0.2s, box-shadow 0.2s",
      }}
    >
      {/* Header */}
      <div
        onClick={() => setOpen((v) => !v)}
        style={{
          display: "flex", alignItems: "center", gap: 12,
          padding: "14px 16px", cursor: "pointer",
          userSelect: "none",
        }}
      >
        <div
          style={{
            width: 32, height: 32, borderRadius: 8, flexShrink: 0,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 13, fontWeight: 700,
            background: open ? "#1A56DB" : "#EFF6FF",
            color: open ? "#fff" : "#1A56DB",
            transition: "background 0.2s, color 0.2s",
          }}
        >
          {section.num}
        </div>
        <span style={{ flex: 1, fontSize: 14, fontWeight: 600, color: "#1F2937" }}>
          {section.title}
        </span>
        <span style={{ color: open ? "#1A56DB" : "#6B7280", transition: "color 0.2s" }}>
          <ChevronIcon open={open} />
        </span>
      </div>

      {/* Body */}
      <div
        style={{
          maxHeight: open ? 2000 : 0,
          overflow: "hidden",
          transition: "max-height 0.35s ease",
        }}
      >
        <div style={{ height: 1, background: "#E5E7EB", margin: "0 16px" }} />
        <div style={{ padding: "14px 16px 16px" }}>
          {section.blocks.map((block, i) => renderBlock(block, i))}
        </div>
      </div>
    </div>
  );
}

// ─── Contact Card ────────────────────────────────────────────────────────────

function ContactCard() {
  return (
    <div
      style={{
        background: "linear-gradient(135deg, #1A56DB 0%, #1E40AF 100%)",
        borderRadius: 14,
        padding: 20,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <ContactSupportIcon />
        <span style={{ color: "#fff", fontSize: 15, fontWeight: 700 }}>12. Contact Us</span>
      </div>
      <p style={{ color: "rgba(255,255,255,0.7)", fontSize: 13, lineHeight: 1.6, marginBottom: 16 }}>
        If you have any questions, concerns, or requests regarding this Privacy Policy or the handling of your personal information, please contact us at:
      </p>
      {contactInfo.map((row, i) => (
        <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
          <div
            style={{
              background: "rgba(255,255,255,0.15)", borderRadius: 7,
              padding: 6, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
            }}
          >
            {contactIconMap[row.icon]}
          </div>
          <span style={{ color: "#fff", fontSize: 13, fontWeight: 500 }}>{row.text}</span>
        </div>
      ))}
    </div>
  );
}

// ─── Footer ──────────────────────────────────────────────────────────────────

function Footer() {
  return (
    <div style={{ padding: "0 0 24px" }}>
      <div
        style={{
          background: "#fff", border: "1px solid #E5E7EB",
          borderRadius: 12, padding: 14, marginBottom: 12,
        }}
      >
        <p style={{ fontSize: 12, color: "#6B7280", fontStyle: "italic", lineHeight: 1.6, textAlign: "center", margin: 0 }}>
          This Privacy Policy is governed by the laws of India, including the Information Technology Act, 2000 and applicable data protection regulations.
        </p>
      </div>
      <p style={{ fontSize: 12, color: "#6B7280", textAlign: "center", margin: 0 }}>
        © 2025 Mani Vasu. All rights reserved.
      </p>
    </div>
  );
}

// ─── Date Chip ───────────────────────────────────────────────────────────────

function DateChip({ icon, label }) {
  return (
    <div
      style={{
        display: "inline-flex", alignItems: "center", gap: 5,
        padding: "5px 10px", background: "#EFF6FF",
        border: "1px solid rgba(26,86,219,0.2)", borderRadius: 20,
        fontSize: 11, color: "#1A56DB", fontWeight: 500,
      }}
    >
      {icon}
      {label}
    </div>
  );
}

// ─── Hero Header ─────────────────────────────────────────────────────────────

function HeroHeader() {
  return (
    <div
      style={{
        background: "linear-gradient(135deg, #1A56DB 0%, #1E40AF 100%)",
        borderRadius: 16, padding: "28px 24px 20px",
        marginBottom: 12, position: "relative", overflow: "hidden",
      }}
    >
      {/* Decorative circles */}
      <div style={{ position: "absolute", right: -20, top: -20, width: 120, height: 120, borderRadius: "50%", background: "rgba(255,255,255,0.07)" }} />
      <div style={{ position: "absolute", left: -15, bottom: -25, width: 80, height: 80, borderRadius: "50%", background: "rgba(255,255,255,0.05)" }} />

      <div
        style={{
          background: "rgba(255,255,255,0.15)", borderRadius: 10,
          padding: 8, display: "inline-flex", alignItems: "center",
          justifyContent: "center", marginBottom: 12,
        }}
      >
        <ShieldIcon />
      </div>
      <div>
        <div style={{ color: "#fff", fontSize: 20, fontWeight: 800, letterSpacing: "0.8px" }}>MANI VASU</div>
        <div style={{ color: "rgba(255,255,255,0.7)", fontSize: 12, marginTop: 2 }}>Recharge Application</div>
      </div>
    </div>
  );
}

// ─── Main Component ──────────────────────────────────────────────────────────

export default function PrivacyPolicyScreen() {
  return (
    <div style={{ background: "#F9FAFB", minHeight: "100vh", padding: "16px" }}>
      <div style={{ maxWidth: 600, margin: "0 auto" }}>

        {/* Hero */}
        <HeroHeader />

        {/* Date chips */}
        <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
          <DateChip icon={<CalendarIcon />} label="Effective: May 3, 2025" />
          <DateChip icon={<UpdateIcon />} label="Updated: May 3, 2025" />
        </div>

        {/* Sections */}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {sections.map((sec, i) => (
            <SectionCard key={sec.num} section={sec} defaultOpen={i === 0} />
          ))}
        </div>

        {/* Contact */}
        <div style={{ marginTop: 8 }}>
          <ContactCard />
        </div>

        {/* Footer */}
        <div style={{ marginTop: 8 }}>
          <Footer />
        </div>

      </div>
    </div>
  );
}